module.exports = __webpack_public_path__ + "img/Character_Kujou_Sara_Thumb.772cc64e.png";